import axiosClient from "./axiosClient";

export const globalSearch = async (params = {}) => {
  const res = await axiosClient.get("/search/", { params });
  return res.data;
};
